import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const STAFF_ROLES = ["employee", "admin", "superadmin"];

export function useAdminAuth() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const raw = localStorage.getItem("kkb_user");
        const token = localStorage.getItem("kkb_token");

        if (raw && token) {
            try {
                const parsed = JSON.parse(raw);
                if (parsed && STAFF_ROLES.includes(parsed.role)) {
                    setUser(parsed);
                }
            } catch {
                localStorage.removeItem("kkb_user");
                localStorage.removeItem("kkb_token");
            }
        }

        setLoading(false); // always runs, outside try/catch
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem("kkb_token");
        localStorage.removeItem("kkb_user");
        setUser(null);
        navigate("/login");
    }, [navigate]);

    const updateUser = useCallback((updatedUser) => {
        setUser(updatedUser);
        localStorage.setItem("kkb_user", JSON.stringify(updatedUser));
    }, []);

    return { user, loading, logout, updateUser };
}